export default __webpack_public_path__ + "static/media/admin-pusat.4f49d355.png";